<div #basemapPanel class="basemap-panel"></div>
